<template>
    <el-form ref="formRef" :disabled="saving" :rules="rules" :model="category" label-position="top">
        <div class="d-flex justify-content-center" style="width: 100%;">
            <img v-if="uri" :src="uri" style="max-width: 140px;" />
        </div>
        <el-form-item prop="name" label="Nome da categoria">
            <el-input name="name" v-model="category.name" />
        </el-form-item>
        <el-form-item prop="image" label="Selecione uma imagem">
            <el-input type="file" ref="image" name="image" @change="selectImage" />
        </el-form-item>


        <el-button plain  :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
            Cadastrar
        </el-button>
    </el-form>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Category } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"
    import { useStore } from "vuex"

    const store = useStore()
    const category = reactive<Category>({
        name: '',
    })

    const rules = reactive<FormRules<Category>>({
        name: [{required: true, message: 'Insira o nome da categori', min: 1}],
        image: [{required: false, message: 'Selecione a imagem'}]
    })

    const image = ref()
    const uri = ref<string>()
    const imageFile = ref<File | Blob>()
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const selectImage = () => {
        imageFile.value = image.value?.input.files[0]
        uri.value = URL.createObjectURL(imageFile.value as File)
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const form = new FormData()
                if (category.name) {
                    form.append("name", category.name)
                }
                if (imageFile.value) {
                    form.append("image", imageFile.value)
                }
                const res = await Api.post('admin/categories', category, form)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Categoria criada com sucesso'})
                    store.commit('setOpenModal', -1)
                    // router.push('/categories')
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
